<template>
    <div class='pageSetting'>
        <el-form :model='setTingObj.page'>
            <el-form-item
                label='模板名称'
                prop='name'
            >
                <el-input
                    v-model='setTingObj.page.name'
                    clearable
                    placeholder='请输入内容'
                    size='small'
                >
                </el-input>
            </el-form-item>
            <el-form-item
                label='页面标题'
                prop='title'
            >
                <template scope="scope">
                    <el-switch v-model="setTingObj.page.navSection"></el-switch>
                    <el-input
                        v-model='setTingObj.page.title'
                        clearable
                        placeholder='请输入内容'
                        size='small'
                    >
                    </el-input>
                </template>
            </el-form-item>
            <el-form-item
                label="标题颜色"
                prop='title'
            >
                <template scope="scope">
                    <br/>
                    <div style="display: flex; align-items: center">
                        <span style="color: #999; margin-right: 20px">{{ setTingObj.page.bgColor.title }}</span>
                        <color :colorObj="setTingObj.page.bgColor"></color>
                    </div>
                    <div style="display: flex; align-items: center">
                        <span style="color: #999; margin-right: 20px">{{ setTingObj.page.titleColor.title }}</span>
                        <color :colorObj="setTingObj.page.titleColor"></color>
                    </div>
                </template>
            </el-form-item>
            <el-form-item
                label='页面弹窗'
                prop='popUpContent'
            >
                <template scope="scope">
                    <el-switch v-model="setTingObj.page.popUp.showStatus"></el-switch>
                    <el-input
                        v-model='setTingObj.page.popUp.title'
                        clearable
                        placeholder='请输入弹窗标题'
                        size='small'
                    >
                    </el-input>
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 6}"
                        v-model='setTingObj.page.popUp.content'
                        clearable
                        placeholder='请输入弹窗内容'
                        size='small'
                    >
                    </el-input>
                </template>
            </el-form-item>
            <el-form-item
                label="广告弹窗"
                prop="popUpAd"
            >
                <template scope="scope">
                    <div class="placeholder" style="width: 100%;height: 1px"></div>
                    <div class="pop-up-ad" v-for="(item,index) in setTingObj.page.popUpAd.list" :key="index">
                        <div class="left">
                            <el-upload
                                class="avatar-uploader"
                                style="width: 80px; height: 80px; text-align: center"
                                :data="item"
                                action=""
                                :show-file-list="false"
                                :http-request="uploadPic"
                            >
                                <img v-if="item.pic" :src="item.pic" class="avatar" size="small" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </div>
                        <div class="right">
                            <div>
                                <span>是否启用</span>
                                <el-switch v-model="item.showStatus"></el-switch>

                                <span style="margin-left: 18px">显示模式</span>
                                <el-button size="mini" @click="clickShowType(item.showType)">{{ item.showType.list.find(element => element.value === item.showType.type).key}}</el-button>
                            </div>
                            <div>
                                <span>广告名称</span>
                                <el-input v-model="item.title" style="width: 180px" size='small' placeholder="请输入广告名称"></el-input>
                            </div>
                            <div>
                                <span>跳转链接</span>
                                <el-input v-model="item.pageLink" style="width: 180px" size='small' placeholder="请输入广告链接"></el-input>
                            </div>
                        </div>
                    </div>
                </template>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { get, post, deleteFun, upload } from '@/utils/request.js';
import color from "@/components/decoration/common/color.vue";

export default {
    components: {color},
    props: {
        setTingObj: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {};
    },
    methods:{
        // 上传图片
        uploadPic(params) {
            console.log(params);
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(`/mpp/image/upload`, formData).then((res) => {
                if(res.success){
                    params.data.pic = res.url
                }
                console.log("res",res)
            });
        },

        // 设置显示模式
        clickShowType(showType){
            if(showType.type == showType.list.length){
                showType.type = showType.list[0].value
            } else {
                showType.type++
            }
        }
    }
};
</script>

<style lang='scss' scoped>
.pageSetting {
    width: 100%;
    height: 100%;

    .pop-up-ad{
        width: 100%;
        height: 130px;
        border-bottom: 1rpx solid #dcdfe6;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left{
            width: 100px;
            height: 100px;
            border: 1px dashed #dcdfe6;
            border-right: 7px;

            img{
                width: 100%;
                height: 100%;
            }
        }

        .right{
            width: 250px;
            display: flex;
            flex-direction: column;

            div{
                display: flex;
                align-items: center;
                flex-wrap: nowrap;

                span{
                    margin-right: 10px;
                }
            }
        }
    }
}
::v-deep .el-upload{
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>